import { Reveal } from "./Reveal";
import { BookCallButton, BlueprintButton } from "./CTA";

export const CtaBand = ({
  title = "Let's Find Your Biggest Growth Opportunity.",
  copy = "Tell us where your agency is today and where you want it to be. We'll review the opportunity honestly.",
  testid = "cta-band",
}) => {
  return (
    <section className="bg-tan relative overflow-hidden" data-testid={testid}>
      <div className="absolute inset-0 geo-pattern-light opacity-[0.08]" />
      <div className="relative max-w-7xl mx-auto px-6 py-20 md:py-28 flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
        <Reveal>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tighter text-cream leading-[1.05] max-w-2xl">
            {title}
          </h2>
          <p className="mt-5 text-cream/80 text-base leading-relaxed max-w-xl">
            {copy}
          </p>
        </Reveal>
        <Reveal delay={0.15} className="flex flex-col sm:flex-row gap-4 shrink-0">
          <BookCallButton dark testid={`${testid}-book-call-button`} />
          <BlueprintButton light testid={`${testid}-audit-button`} />
        </Reveal>
      </div>
    </section>
  );
};
